import { SignOutDocument, SignOutMutation } from "__gen__/authGatewaySdk";
import authServiceClient from "./authGatewayClient";

export default () => {
  return authServiceClient.mutate<SignOutMutation>({
    mutation: SignOutDocument,
  });
};
